import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'ham-badge-button',
    template: `
        <button
            #nativeButton
            class="ham-button"
            [type]="type || 'button'"
            [disabled]="disabled || isClicked"
            [class.active]="active"
            [class.inactive]="inactive"
            (click)="handleClick($event)"
        >
            <span class="badge-text" *ngIf="!hideText"><ng-content></ng-content></span>
            <span class="icon" *ngIf="icon">
                <i [style]="iconStyle"></i>
            </span>
        </button>
    `,
    styleUrls: ['./badgeButton.component.scss'],
})
export class HamBadgeButtonComponent {
    @ViewChild('nativeButton', { static: true }) nativeButton!: ElementRef;
    @Input() icon: string | null = null;
    @Input() rightIcon: string | null = null;
    @Input() variant: 'primary' | 'gray' | 'red' | 'teal' | 'green' | 'white' | 'transparent' | 'glass' | 'plain' =
        'primary';
    @Input() outline: boolean = false;
    @Input() type: string | null;
    @Input() disabled: boolean = false;
    @Input() active: boolean = false; // Add active input property
    @Input() inactive: boolean = false; // Add inactive input property
    @Output() buttonClick = new EventEmitter<Event>(); // Custom output event
    @Input() hideText: boolean = false;

    @HostBinding('class') get hostClasses(): string {
        return `ham-badge-button ${this.variant}`;
    }

    get iconStyle() {
        return this.icon ? { '-webkit-mask-image': `url(${this.icon})`, 'mask-image': `url(${this.icon})` } : {};
    }

    isClicked = false; // New property to track if the button was clicked

    constructor(private cdr: ChangeDetectorRef) {}

    handleClick(event: Event) {
        if (this.disabled || this.isClicked) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        this.isClicked = true; // Temporarily disable button
        this.buttonClick.emit(event); // Emit custom event when the button is clicked

        // Re-enable the button after a delay (e.g., 300 milliseconds)
        setTimeout(() => {
            this.isClicked = false;
            this.cdr.detectChanges(); // Manually trigger change detection
        }, 150); // You can adjust the debounce delay as needed
    }
}
